export default __webpack_public_path__ + "static/successOrderBackground-4886d14167ddcdeff8d2ef70733d6c9e.webm";